export const PET_REQUEST = "PET_REQUEST";
export const REQUEST_DELETE = "REQUEST_DELETE";
export const PET_DELETE = "PET_DELETE";
export const PET_NEED = "PET_NEED";
export const NEED_DELETE = "NEED_DELETE";
